/*
 * @Author: 俊昌 junchang.zhang@wahool.com
 * @Date: 2024-01-25 10:31:51
 * @LastEditors: 俊昌 junchang.zhang@wahool.com
 * @LastEditTime: 2024-01-25 12:03:09
 * @FilePath: /flowBusinessui/src/api/supplier/amazon/amazon.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import request from '@/utils/request'

/**
 * @description: 获取amaxon设置数据
 * @param {*} data
 * @return {*}
 */
export function getSettingsTemplate(data = {}) {
  return request.GET('/supplier/amazon-account/settings-template', data)
}
/**
 * @description: 设置页面接口
 * @param {*} data
 * @return {*}
 */
export function setSettings(data = {}) {
  return request.POST('/supplier/amazon-account/settings', data)
}
/**
 * @description: 查询单个绑定记录
 * @param {*} id
 * @return {*}
 */
export function getAuthInfo(id) {
  return request.GET(`/supplier/amazon-account/get/${id}`)
}

export function getAmazonAccountList() {
  return request.GET('/supplier/amazon-account/list')
}
